import JobEnquiry from ".";

export const jobEnquiryRoutes = () => [
  {
    path: "/admin/job-enquiry",
    component: JobEnquiry,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];